import React from 'react';

export default function ShowcaseSection() {
  return (
    <section className="bg-gradient-to-b from-blue-600 to-blue-400 py-16 px-4 flex flex-col md:flex-row items-center justify-center gap-8">
      <div className="flex-1 max-w-md text-white space-y-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-2">Everything you need to run your books.</h2>
        <p className="mb-4 text-blue-100">Well, everything you need if you don't mind doing it without the smell of dry-erase markers.</p>
        <ul className="space-y-4">
          <li><span className="font-semibold">Attendance Tracking:</span> Mark students present, absent, tardy, or excused without printing a single sheet.</li>
          <li><span className="font-semibold">Class Management:</span> Set up classes and assign teachers—no spreadsheets, no headaches.</li>
          <li><span className="font-semibold">Student Rosters:</span> Add, update, and manage student info like a pro (or at least like someone who doesn’t forget names).</li>
          <li><span className="font-semibold">Reports:</span> Download your attendance data as a spreadsheet and do whatever magical things admins do with Excel.</li>
        </ul>
      </div>
      <div className="flex-1 max-w-xl w-full flex justify-center">
        {/* Placeholder for UI screenshot or demo */}
        <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
          <div className="font-bold text-blue-700 mb-4">Attendance (Demo)</div>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500">
                <th>Name</th>
                <th>Status</th>
                <th>Class</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Stacey Bobb</td><td>Present</td><td>Math</td><td>2025-05-10</td></tr>
              <tr><td>Derek Forbes</td><td>Absent</td><td>Science</td><td>2025-05-10</td></tr>
              <tr><td>Garth Leemow</td><td>Tardy</td><td>English</td><td>2025-05-10</td></tr>
              <tr><td>Ilyssa Bodah</td><td>Excused</td><td>History</td><td>2025-05-10</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
} 